exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".item-row[data-v-735e29fb]{display:-webkit-box;display:-webkit-flex;display:flex;-webkit-box-align:center;-webkit-align-items:center;align-items:center;margin-bottom:0.05333rem}.item-row[data-v-735e29fb]:last-child{margin-bottom:0}", ""]);

// exports
